import api from 'api';
import makeSorter from 'lib/makeSorter';
import { regexpSearch } from 'lib/searchFns';
import ___ from '../constants';
import { forEach, result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';

const dateColumns = [
    'est_arrival_date',
];

const initialState = {
    currentEditRow: null,
    currentEditHeader: null,
    originalEditRow: null,
    detailLines: null,
    originalOrders: [],
    filteredOrders: [],
    failedDocEntries: [],
    errors: [],
    loading: false,
    searchLoading: false,
    columns: [],
    filteredSource: [],
    searchedSource: [],
    sortOrder: false,
    sortField: false,
    sorting: [],
    filters: [],
    requestedPage: 0,
    forceReload: false,
    //warehousePerson: '',
    logged_in_rep: '',
    filterValues: {
        order_date_formatted: null,
        event_date: null,
        status: null,
    },
};

export const types = {
    SET_STATE: 'PRODUCTION/SET_STATE',
    SET_FILTER_VALUES: 'PRODUCTION/SETFILTERVALUES',
    START_LOADING: 'PRODUCTION/START_LOADING',
    CHANGE_FILTERS: 'PRODUCTION/CHANGE_FILTERS',
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            return { ...state, ...action.data };

        case types.SET_FILTER_VALUES:
            return {
                ...state,
                filterValues: {
                    ...state.filterValues,
                    ...action.data,
                },
            };

        case types.START_LOADING:
            return {
                ...state,
                requestedPage: action.data.requestedPage,
                take: action.data.take,
            };

        case types.CHANGE_FILTERS:
            return {
                ...state,
                forceReload: true,
                requestedSkip: 0,
                allOrders: [],
                filters: action.data.filters,
            };


        default:
            return state;
    }
};




export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    setFilterValues: (data) => ({ type: types.SET_FILTER_VALUES, data }),

    startLoading: (data) => ({ type: types.START_LOADING, data }),

    setCurrentEditRow: (row) => async (dispatch, getState) => {
        //console.log('[Production.redux.js] setCurrentEditRow');
        //console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getProductionOrders: () => async (dispatch, getState) => {
        console.log('[Production.redux.js] getProductionOrders()');
        const state = getState();
        dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Warehouse.GetProductionOrderLines
            let result = await api.get('/warehouse/production');
            console.log(result)
            //console.log(result.productionOrders.recordset)
            let _result = result.productionOrders.recordset;
            //console.log(typeof _result)
            // console.log(typeof _result[0])
            //console.log(_result.length);

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value)
            }
            // console.log(_arrayResult)
            // console.log(typeof _arrayResult)

            dispatch(actions.setState({
                // productionOrders: [..._obj],
                // filteredSource: [..._obj],
                originalOrders: _arrayResult,
                filteredOrders: _arrayResult,
                filteredSource: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('[Production.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                originalOrders: [],
                filteredOrders: [],
                filteredSource: [],
                loading: false
            }));
        }
    },

    searchCurrent: ({ searchValue = '', excludeList = [], includeList = [], exactList = [] }) => (dispatch, getState) => {
        console.log('[Production.redux] searchCurrent');
        console.log('searchValue', searchValue ? searchValue : 'searchValue was NULL')

        const finalIncludeList = subtractFields(includeList, excludeList, exactList);
        const finalExactList = exactList.filter(field => !excludeList.includes(field));

        dispatch(actions.setState({ searchLoading: true }));

        setTimeout(() => {
            const { filteredSource, sortOrder, sortField } = getState().warehouseProd;
            let searchedSource = [];

            if (filteredSource) {
                for (let bp of filteredSource) {
                    if (searchValue === '') {
                        searchedSource.push(bp);
                        continue;
                    }

                    const matchedInclude = matchesIncludeFields(bp, finalIncludeList, searchValue);
                    const matchedExact = matchesExactFields(bp, finalExactList, searchValue);

                    if (matchedInclude || matchedExact) {
                        searchedSource.push(bp);
                    }
                }
            } else {
                console.error('filteredSource falsey')
                // console.error(filteredSource)
                // console.error(typeof filteredSource)
            }
            dispatch(actions.setState({
                searchedSource: [...searchedSource],
                searchValue,
                hasFilterBeenApplied: true,
                hasOrder: true,
            }));

            dispatch(actions.sortCurrent({
                field: sortField,
                order: sortOrder
            }));

            dispatch(actions.setState({ searchLoading: false }));
        }, 1000); // 1 second delay
    },

    sortCurrent: ({ field, order }) => (dispatch, getState) => {
        // console.log('[Production.redux] sortCurrent ')
        // console.log(field)
        // console.log(order)
        let { searchedSource, columns } = getState().warehouseProd;

        const numberSortColumns = [
            ...dateColumns,
            'card_code',
        ];

        let newColumns = columns.map((col) => {
            if (col.dataIndex === field) {
                return { ...col, sortOrder: order }
            } else {
                return { ...col, sortOrder: false }
            }
        });

        let productionOrders = searchedSource; // THIS

        if (field !== false) {
            let type = 'string';
            if (numberSortColumns.indexOf(field) !== -1) {
                type = 'number';
            }
            productionOrders = searchedSource.sort(makeSorter(type, field));
        }

        if (order === 'ascend') {
            productionOrders = productionOrders.reverse();
        }

        dispatch(actions.setState({
            columns: newColumns,
            filteredOrders: [...productionOrders],
            sortOrder: order,
            sortField: field,
        }));
    },

    getProductionPRODetails: (existingRow) => async (dispatch, getState) => {
        console.log('[Production.redux.js] getProductionPRODetails()');
        const state = getState().warehouseProd;
        dispatch(actions.setState({ loading: true }));
        // console.log(state.currentEditRow);
        // console.log(state.currentEditRow.docEntry);
        // console.log(existingRow);

        try {
            // QUERY Warehouse.GetPROFinishedGood
            let result = await api.get(`/warehouse/production/pro-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docEntry: state.currentEditRow.docEntry,
                },
            });
            // console.log(result);
            // console.log(result.detailLines.recordset);

            let _detailLines = [...result.detailLines.recordset];

            // add existing record.finishedQty to the new query result
            let editLine = _detailLines.find(row => row.docEntry === existingRow.docEntry);
            editLine.finishedQty = existingRow.finishedQty;

            dispatch(actions.setState({ detailLines: _detailLines }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    submitToIssue: (rows, searchTerm, popSuccessCB, popPartialCB, popFailureCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] submitToIssue()');
        const state = getState().warehouseProd;

        if (!rows || rows.length <= 0) {
            popFailureCB();
            return null;
        }
        //console.log(rows);

        // combine rows by base DocEntry so they can be on the same GoodsIssue
        function groupByDocEntry(array) {
            const groupedArrays = {};
            array.forEach(obj => {
                const _docEntry = obj.docEntry;
                if (!groupedArrays[_docEntry]) {
                    groupedArrays[_docEntry] = [];
                }
                groupedArrays[_docEntry].push(obj);
            });
            return Object.values(groupedArrays);
        }

        const groupedRows = groupByDocEntry(rows);
        // console.log(groupedRows);

        dispatch(actions.setState({ loading: true, failedDocEntries: [], errors: [] }));
        try {

            let failedDocEntries = [];
            let _errors = [];

            let result = await api.put('/warehouse/write-goods-issue',
                {
                    rows,
                    groupedRows,
                    //Comments: currentEditRow.notes,
                });
            console.log(result);
            // console.log(result.success);
            // console.log(result.responses);
            // console.log(result.statuses);

            let ordersWithErrorFromSAP;

            let _failedResponses = result.responses.filter((rsp) => {
                //console.log(rsp);
                return !rsp.successful;
            });


            let _failedStatuses = result.statuses.filter((stat) => {
                // NOTE result.statuses has both the error message and the grouped docEntry
                //console.log(stat);
                return !stat.key;
            });

            if (_failedResponses.length > 0) {
                console.log('_failedResponses ');
                console.log(_failedResponses);
                //popFailureCB();
            }

            if (_failedStatuses.length > 0) {
                console.log('_failedStatuses ');
                console.log(_failedStatuses);
                _failedStatuses.forEach((failure) => {
                    //console.log(failure);
                    //console.log(failure.error);
                    failedDocEntries.push(failure.groupDocEntry);
                });

                let OGorders = state.originalOrders; // slight BUG where the table populates back to unfiltered, but then properly filters again after a moment

                // failureMap: groupDocEntry -> failure object
                const failureMap = new Map(
                    _failedStatuses.map(f => [Number(f.groupDocEntry), f])
                );
                //console.log('failureMap', failureMap)

                const { orders, errors } = OGorders.reduce((acc, ordr) => {
                    const failure = failureMap.get(Number(ordr.docEntry));

                    if (failure) {
                        // console.log('match error, add issueErrorMsg property');
                        //console.log(ordr);
                        // console.log(failure.error[0]);

                        // 1 ** dont need to pop a seperate error notification for backflush items since they didnt enter a quantity
                        if (ordr.IssueType !== ___.PRODUCTION_MANUAL) {
                            acc.errors.push(`# ${ordr.docNum} ${failure.error[0]}`);
                        } else {
                            console.log('skipping backflush item')
                        }

                        // 2 ** but do need to keep the rows with sibling errors shown on the table 
                        acc.orders.push({
                            ...ordr,
                            issueErrorMsg: failure.error[0]
                        });

                    } else {
                        acc.orders.push(ordr);
                    }
                    return acc;
                }, { orders: [], errors: [] });

                ordersWithErrorFromSAP = orders;
                _errors = errors;
            }

            // console.log('ordersWithErrorFromSAP', ordersWithErrorFromSAP);
            // console.log('_errors', _errors);
            //console.log('failedDocEntries');
            //console.log(failedDocEntries);

            if (result.success === 'success') {
                console.log('submitToIssue success');
                let updateArray = ordersWithErrorFromSAP ? ordersWithErrorFromSAP : []
                popSuccessCB(searchTerm);
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntries: failedDocEntries,
                    originalOrders: updateArray, // yes this is on purpose, IMPORTANT redundancy for how search and filters work
                    filteredOrders: updateArray,
                    filteredSource: updateArray,
                    errors: _errors
                }));

                dispatch(actions.getProductionOrders());

            } else if (result.success === 'partial') {
                console.log('submitToIssue partial');
                popPartialCB(searchTerm);

                // IMPORTANT issuing rows that return a partial success would leave the successful rows 
                // on-hand count as it was before it was accepted, since we are not fetching new rows
                // this code will adjust the quantities and stitch the results back into the table
                const qtyMap = new Map(rows.map(r => [r.docEntry, r.qtyToIssue]));
                const updatedOrders = ordersWithErrorFromSAP.map(order => {
                    const submittedQty = qtyMap.get(order.docEntry) || 0;
                    // Check if this order was NOT in the failedDocEntries
                    if (!failedDocEntries.includes(order.docEntry)) {
                        // update quantities for successful issue
                        return {
                            ...order,
                            issuedQty: (order.issuedQty || 0) + submittedQty,
                            onHandQty: (order.onHandQty || 0) - submittedQty
                        };
                    }
                    // failed rows keep original data + error message
                    return order;
                });

                dispatch(actions.setState({
                    loading: false,
                    failedDocEntries: failedDocEntries,
                    originalOrders: updatedOrders, // yes this is on purpose, IMPORTANT redundancy for how search and filters work
                    filteredOrders: updatedOrders,
                    filteredSource: updatedOrders,
                    errors: _errors,
                }));

            } else {
                console.log('submitToIssue else');
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntries: failedDocEntries,
                    originalOrders: ordersWithErrorFromSAP, // yes this is on purpose, IMPORTANT redundancy for how search and filters work
                    filteredOrders: ordersWithErrorFromSAP,
                    filteredSource: ordersWithErrorFromSAP,
                    errors: _errors,
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            popFailureCB();
        }
    },

    writeProductionOrder: (currentEditRow, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writeProductionOrder()');

        console.log(currentEditRow);

        dispatch(actions.setState({ loading: true }));
        try {
            let result = await api.put('/warehouse/write-goods-receipt-pro',
                {
                    BaseDocEntry: currentEditRow.docEntry,
                    BaseDocType: 202, // OR currentEditRow.objType
                    Qty: currentEditRow.finishedQty, // NOTE this is different than the incoming qty
                    Comments: currentEditRow.notes,
                    // TODO_UNUSED submit unused components
                });
            console.log(result);
            //console.log(result.data);

            console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getProductionOrders());
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },

    submitToFinish: (rows, searchTerm, popSuccessCB, popFailureCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] submitToFinish()');

        const state = getState().warehouseProd;

        if (!rows || rows.length <= 0) {
            popFailureCB();
            return null;
        }
        //console.log(rows);

        dispatch(actions.setState({ loading: true, failedDocEntriesBatch: [], errors: [] }));
        try {

            let failedDocEntriesBatch = [];
            let _errors = [];

            let result = await api.put('/warehouse/write-goods-receipt-batch',
                {
                    rows,
                    //groupedRows,
                });
            console.log(result);
            //console.log(result.data);
            //console.log(result.success);
            //console.log(result.responses);
            //console.log(result.statuses);

            let _failedResponses = result.responses.filter((rsp) => {
                //console.log(rsp);
                return !rsp.successful;
            });

            let _failedStatuses = result.statuses.filter((stat) => {
                //console.log(stat);
                return !stat.key;
            });

            if (_failedResponses.length > 0) {
                console.log('_failedResponses ');
                console.log(_failedResponses);
            }

            if (_failedStatuses.length > 0) {
                console.log('_failedStatuses ');
                console.log(_failedStatuses);
                _failedStatuses.forEach((failure) => {
                    //console.log(failure);
                    //console.log(failure.error);
                    failedDocEntriesBatch.push(failure.groupDocEntry);
                    _errors.push(failure.error[0]); // TODO_HARDCODE_ERROR_INDEX
                });
            }

            console.log('failedDocEntriesBatch');
            console.log(failedDocEntriesBatch);

            if (result.success === 'partial') {
                console.log('submitToFinish partial success');
                popSuccessCB(searchTerm);
                // TODO what can we do with erroneous rows
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntriesBatch: failedDocEntriesBatch,
                    errors: _errors,
                }));

                // for this feature we are not concerned with stitching and adding errors to the rows, so just get new data
                dispatch(actions.getProductionOrders());
                
            } else if (result.success && result.success === 'success') {
                console.log('submitToFinish success');
                popSuccessCB(searchTerm);
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntriesBatch: failedDocEntriesBatch,
                    errors: _errors
                }));
                dispatch(actions.getProductionOrders());

            } else {
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntriesBatch: failedDocEntriesBatch,
                    errors: _errors,
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            popFailureCB();
        }
    },

    writePurchaseOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writePurchaseOrder()');
        //console.log(currentEditRow);
        //console.log(editDetailsLines);

        const state = getState().warehouseProd;
        dispatch(actions.setState({ loading: true }));

        let _filtered = editDetailsLines.filter((r) => (r.orderQty && r.orderQty > 0));
        //console.log(_filtered);

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
            submitRows: _filtered,
        };

        // TODO_BLANK_NOTES need to prevent writing comments if they are blank, except when they would be intentionally blank
        if (currentEditRow.notes && currentEditRow.notes !== '') {
            sendBody.Comments = currentEditRow.notes;
        }

        try {
            let result = await api.put('/warehouse/write-grpo',
                sendBody);
            console.log(result);
            console.log(result.data);

            //console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getProductionOrders());
                //dispatch(actions.setState({ purchaseOrders: result.purchaseOrders.recordset }));
            }

            //console.log(result.errorMsg); // errorMsg: "One of the base documents has already been closed"

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },
};
